export default __webpack_public_path__ + "device-group.png";